import { Injectable } from '@angular/core';
import { ServicingBaseClass } from '@common/components';
import { CommonLibService } from '@lib/services';
import {
  GetETicketItineraryReceiptStore,
  resetGetETicketItineraryReceipt,
  selectGetETicketItineraryReceiptIsFailureStatus,
  selectGetETicketItineraryReceiptState,
  setGetETicketItineraryReceiptFromApi,
} from '@common/store/get-e-ticket-itinerary-receipt';
import { Store, select } from '@ngrx/store';
import { DefaultService as Api } from 'src/sdk-servicing/api/default.service';
import { Observable } from 'rxjs';
import { filter, map, withLatestFrom } from 'rxjs/operators';
import { GetETicketItineraryReceiptRequest, GetETicketItineraryReceiptResponse } from 'src/sdk-servicing';

/**
 * S05-P031【航空券PDF取得API】を操作するためのサービス
 */
@Injectable()
export class GetETicketItineraryReceiptStoreService extends ServicingBaseClass {
  private result$!: Observable<GetETicketItineraryReceiptResponse | null>;
  private failure$!: Observable<boolean>;

  public get res$() {
    return this.result$;
  }

  constructor(
    private store: Store<GetETicketItineraryReceiptStore>,
    private api: Api,
    private common: CommonLibService
  ) {
    super();
    this.result$ = this.store.pipe(
      select(selectGetETicketItineraryReceiptState),
      map((state) => state.model)
    );
    this.failure$ = this.store.pipe(
      select(selectGetETicketItineraryReceiptIsFailureStatus),
      filter((isFailure) => isFailure)
    );
  }

  setupHandler(
    responseHandler: (response: GetETicketItineraryReceiptResponse) => void,
    errorHandler: (apiErrorCode?: string) => void
  ) {
    this.subscribeService(this.result$, (result) => {
      if (result) {
        responseHandler(result);
      }
    });
    this.subscribeService(
      this.failure$.pipe(
        withLatestFrom(this.common.apiErrorResponseService.getApiErrorResponse$(), (_, state) => state)
      ),
      (model) => {
        const errors = model?.errors;
        const apiErrorCode = errors && errors.length ? errors[0].code : undefined;

        errorHandler(apiErrorCode);
      }
    );
  }

  callApi(req: GetETicketItineraryReceiptRequest) {
    const call = this.api.ordersGetETicketItineraryReceiptPost(req);
    this.store.dispatch(setGetETicketItineraryReceiptFromApi({ call }));
  }
  /**
   * ストアを空にします。
   */
  clearStore(): void {
    this.store.dispatch(resetGetETicketItineraryReceipt());
  }

  override destroy(): void {}
}
